enum DoNotShowAgainKey {
  SEND_INTERNAL_ONLY = 'send_internal_only',
  EDITING_CALENDER_WARNING = 'editing_calendar_warning',
  SEND_NOW_ONE_CLICK_TASK_CREATION = 'send_now_one_click_task_creation',
  GREENHOUSE_HARVEST_V3_DIALOG = 'greenhouse_harvest_v3_dialog',
  // PRD-271 — distinct per-page keys so the two banners can be dismissed independently.
  INITIAL_PORTAL_DEFAULT_THEME_MIGRATED_BANNER = 'initial_portal_default_theme_migrated_banner',
  INITIAL_PORTAL_CREATED_BANNER = 'initial_portal_created_banner',
}

export default DoNotShowAgainKey;
